// assets
import { IconUsers, IconUserPlus } from '@tabler/icons';

// constant
const icons = {
    IconUsers,
    IconUserPlus
};

const pacientes = {
    id: 'pacientes',
    title: 'Pacientes',
    caption: 'Administración de Pacientes',
    type: 'group',
    children: [
        {
            id: 'listado-pacientes',
            title: 'Listado de Pacientes',
            type: 'item',
            icon: icons.IconUsers,
            url: '/pacientes'
        },
        {
            id: 'nuevo-paciente',
            title: 'Nuevo Paciente',
            type: 'item',
            icon: icons.IconUserPlus,
            url: '/pacientes/nuevo'
        }
    ]
};

export default pacientes;
